const dictionaryMarkdownActions = {
  CLOSE_DICTIONARY_MARKDOWN: 'CLOSE_DICTIONARY_MARKDOWN',
  DESTROY_DICTIONARIES_MARKDOWN: 'DESTROY_DICTIONARIES_MARKDOWN',
  FETCH_DICTIONARY_MARKDOWN: 'FETCH_DICTIONARY_MARKDOWN',
  FETCH_DICTIONARY_MARKDOWN_ERROR: 'FETCH_DICTIONARY_MARKDOWN_ERROR',
  FETCH_DICTIONARY_MARKDOWN_SUCCESS: 'FETCH_DICTIONARY_MARKDOWN_SUCCESS',
};

export const dictionaryMarkdownCategories = ['open'];

export default dictionaryMarkdownActions;
